export default __webpack_public_path__ + "static/media/equity-icon.2f8318b0.svg";